<template>
  <Modal
    :id="'cmp-royalty-royalty_account-sidewindow-add_access_form'"
    @cancelled="onCancel"
  >
    <template slot="header">B2B Access</template>

    <template slot="body">
      <SearchList
        style="padding-bottom: 10px"
        :id="'b2b_search'"
        ref="searchList"
        :items="unrelated_users"
        :keyProperty="'external_user_id'"
        :label="'user_name'"
        :headers="[
          { text: 'Username' },
          { text: 'Given Name' },
          { text: 'Email' },
        ]"
        @selected="onSelected"
        @searched="searchExternalUser"
      >
        <template v-slot:item="{ item }">
          <tr class="dt-table2--row">
            <dt
              class="dt-table2--column"
              style="border-right: 1px solid #fefefe"
            >
              <div class="ut-flex">
                <div style="flex: 0.2" class="checkbox-container">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      :name="item.external_user_id"
                      :id="item.external_user_id"
                      :checked="selected_users.has(item.external_user_id)"
                      @click="
                        (e) => onCheckboxChange(e, 'external_user_id', item)
                      "
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
                <div style="flex: 0.8" class="txtov">
                  {{ item.user_name }}
                </div>
              </div>
            </dt>
            <!-- <dt class="dt-table2--column">
              <span class="txtov">{{ item.user_name }}</span>
            </dt> -->
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.given_name }}</span>
            </dt>
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.email }}</span>
            </dt>
          </tr>
        </template>
      </SearchList>
      <span style="color: red">
        By clicking on SAVE, you confirm that this EXTERNAL USER will have
        access to ROYALTY STATEMENTS! The charts & statements contain sensitive
        information like sales / contracts / royalties / payments. If you wish
        to cancel this access, you can do so here at any time!
      </span>
    </template>

    <template slot="options">
      <button
      
        style="max-width: 200px"
        @click.stop="onAddClick"
        class="dt-button v1 with-ico s6"
      >
        Create New External User
      </button>
       <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { Subject } from "rxjs";
import InputField from "../../../../plugins/text-field/input-field";
import { subscribeSubject } from "../../../../utility";
import { AccountsService } from "../../services/accounts.service";
import SearchList from "@dtplugins/search-list/search-list";
import { addRemoveSet } from "../../../../utility";
export default {
  props: ["selectedAccountDetails"],
  components: {
    Modal,
    InputField,
    SearchList,
  },

  data: function () {
    return {
      unrelated_users: [],
      searchString: null,
      searchSubject$: new Subject(),
      searchSize: "single",
      selected_users: new Set(),
    };
  },
  mounted: function () {
    AccountsService.searchExternalUsers(
      this.selectedAccountDetails?.account?.royalty_account_id,
     null
    ).then((res) => {
      this.unrelated_users = res.data.unrelated_users;
    });
  },
  computed: {
    royalty_account_id: function () {
      return this.$route.params.royalty_account_id;
    },
    searchStringLength: function () {
      if (this.searchString.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    hRowMarginRight: function () {
      if (this.unrelated_users.length > 380 / 28) {
        return "28px";
      }
    },
  },
  methods: {
    addChecklist: function (e) {},
    onCancel: function (e) {},

    searchExternalUser: function (searchString) {
      this.searchString = searchString;
      AccountsService.searchExternalUsers(
        this.selectedAccountDetails?.account?.royalty_account_id,
        searchString
      ).then((res) => {
        this.unrelated_users = res.data.unrelated_users;
      });
    },
    onCheckboxChange: function (event, name, item) {
      const value = event.target.checked;
      this.selected_users = addRemoveSet(
        event.target.checked,
        this.selected_users,
        item.external_user_id
      );

      console.log("WWWW", item.external_user_id, value);
    },

    onSelected: function (payload) {
      this.selected_users = payload;
    },
    async onOkClick() {
      const selected_user_ids = Array.from(this.selected_users).join(",");
      const res = await AccountsService.addExternalUser(
        this.selectedAccountDetails?.account?.royalty_account_id,
        selected_user_ids
      );
      if (res.data.done == 1) {
        const res = await AccountsService.fetchRoyaltyExternalUsers(
          this.selectedAccountDetails?.account?.royalty_account_id
        );

        this.$emit("added", res.data.related_ext_users);
      }
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onAddClick: function () {
      this.$emit("add_click", "new_access_form");
    },
  },
};
</script>

<style lang="scss" >
.cmp-royalty-royalty_account-sidewindow-add_access_form {
  .dt-table2 {
    --body-height: 250px;
  }
  .dt-table2.search-list {
    --row-margin: 0px 4px;
  }
  .ut-flex {
    .checkbox-container {
      flex: 0.1 !important;
    }

    .txtov {
      flex: 0.9 !important;
    }
  }
}
</style>
